import React, { useState } from 'react';
import { Check } from 'lucide-react';

const PrcingPreview: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  
  const tabs = [
    { name: 'Tiny', price: '₹300', period: '500 wheels' },
    { name: 'Small', price: '₹500', period: '1000 wheels'},
    { name: 'Medium', price: '₹1300', period: '3000 wheels' },
    { name: 'Large', price: '₹2000', period: '5000 wheels',  popular: true },
    { name: 'Huge', price: '₹3700', period: '10,000 wheels'},
    { name: 'Gaint', price: '₹15,000', period: '50,000 wheels' },
  ];
  
  const features = [
    { name: 'Wheel credit tracking', basic: true, pro: true, enterprise: true },
    { name: 'Mobile app access', basic: true, pro: true, enterprise: true },
    { name: 'Real-time reports', basic: true, pro: true, enterprise: true },
    { name: 'Employee accounts', basic: true, pro: true, enterprise: true},
    { name: 'Priority support', basic: true, pro: true, enterprise: true },
    { name: 'Custom analytics', basic: true, pro: true, enterprise: true },
  ];

  return (
    <section id="pricing" className="py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Wheel Credit Packages
          </h2>
          <p className="text-lg text-gray-600">
            Purchase wheel credits in bulk and save more. Perfect for parking lots of all sizes.
          </p>
        </div>
        
        <div className="flex justify-center mb-8">
          <div className="inline-flex p-1 bg-gray-100 rounded-lg">
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`px-6 py-2 text-sm font-medium rounded-md relative ${
                  activeTab === index
                    ? 'bg-white text-blue-600 shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
                onClick={() => setActiveTab(index)}
              >
                {tab.name}
                {tab.popular && (
                  <span className="absolute -top-2 -right-2 bg-blue-600 text-white text-xs px-2 py-0.5 rounded-full">
                    Popular
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
        
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl mx-auto border border-gray-200">
          <div className="p-8 text-center border-b border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">{tabs[activeTab].name}</h3>
            <div className="flex items-baseline justify-center">
              <span className="text-4xl font-extrabold text-gray-900">{tabs[activeTab].price}</span>
              <span className="ml-1 text-xl text-gray-500">for {tabs[activeTab].period}</span>
            </div>
            {/* <button className="mt-6 bg-blue-600 text-white w-full py-3 rounded-md font-medium hover:bg-blue-700 transition-colors duration-200">
              Purchase Credits
            </button> */}
          </div>
          
          <div className="p-8">
            <h4 className="text-lg font-medium text-gray-900 mb-4">Package includes:</h4>
            <ul className="space-y-4">
              {features.map((feature, index) => {
                const value = activeTab === 0 ? feature.basic : activeTab === 1 ? feature.pro : feature.enterprise;
                
                return (
                  <li key={index} className="flex items-start">
                    <div className="flex-shrink-0">
                      {value ? (
                        <Check className="h-5 w-5 text-green-500" />
                      ) : (
                        <span className="block h-5 w-5 text-gray-300">―</span>
                      )}
                    </div>
                    <p className="ml-3 text-gray-700">
                      <span className="font-medium text-gray-900">{feature.name}</span>
                      {typeof value === 'string' && (
                        <span className="ml-2 text-gray-500">({value})</span>
                      )}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrcingPreview;